export {};

NLMK.checkboxPrivacy = checkboxPrivacy;

$(checkboxPrivacy);

function checkboxPrivacy() {
    const $checkboxPrivacy = $('.js-checkbox-privacy');

    $checkboxPrivacy.each(function() {
        $(this).on('click', function() {
            const isCheck = $(this).prop('checked');

            const $btnSubmit = $(this)
                .closest('form')
                .find('.js-checkbox-privacy-submit');

            $btnSubmit.prop('disabled', isCheck);
        });
    });
}



// WEBPACK FOOTER //
// ./js/main/module/form-privacy.js